import { ApsContentMask } from 'UserExperience/portal-vnext';

const ContentMask = ({isTrayOpen, closeTray}) => {

  const contentMaskClass = isTrayOpen ? 'content-mask-open' : '';

  return (
    <ApsContentMask
      className={contentMaskClass}
      onClick={closeTray}
    />
  );
};

export default ContentMask;